import _ from 'lodash';
import React from 'react';
import { useRouter } from 'next/router';
import { useObserver } from 'mobx-react-lite';

import useCart from 'shared/hooks/use-cart';
import useUI from 'hooks/use-ui';
import useDispensary from 'src/dispensary/hooks/use-dispensary';
import useDispensarySpecials from 'src/dispensary/hooks/use-dispensary-specials';
import useViewportVisibility from 'hooks/use-viewport-visibility';
import usePaths from 'src/hooks/use-paths';
import { OffersCarousel } from './offers-carousel';

export function SpecialOffersCarousel(props) {
  const UI = useUI();
  const cart = useCart();
  const isMedical = useObserver(() => cart?.isMedical);
  const { dispensary } = useDispensary();
  const router = useRouter();
  const { section } = props;
  const { ref, hasBeenVisible } = useViewportVisibility();
  const { loading, specials } = useDispensarySpecials();
  const offers = _.filter(specials, [`specialType`, `bogo`]);
  const { href, route } = usePaths({ specials: true });

  async function handleOfferClick(bogoId) {
    await router.push(`/${UI.dispensaryRootUrl}/${dispensary.cName}/specials/offer/${bogoId}`);
  }

  if (!offers?.length && !loading && hasBeenVisible) {
    return null;
  }

  const sectionProps = {
    ...props,
    carouselType: `offers`,
    displayGradient: false,
    hasBeenVisible,
    handleOfferClick,
    isLoading: loading,
    isMedical,
    linkLabel: section.linkLabel,
    label: `Offers`,
    specials: offers,
    href,
    route,
  };
  return <OffersCarousel ref={ref} {...sectionProps} />;
}
